import MuiDivider from '@mui/material/Divider';
/**
 * Pigment [Divider](https://pigment.customink.com/?path=/docs/components-divider)
 */
var Divider = MuiDivider;
export default Divider;
//# sourceMappingURL=Divider.js.map